import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { AuthContextProvider } from './context/AuthContext'
import { CountryContextProvider } from './context/CountryContext'
import { CardContextProvider } from './context/CardContext'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<React.StrictMode>
		<CountryContextProvider>
			<CardContextProvider>
				<AuthContextProvider>
					<App />
				</AuthContextProvider>
			</CardContextProvider>
		</CountryContextProvider>
	</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
